import { type CodewordId, codewordIdSchema } from './codeword.js';
import { z } from 'zod';

export const authErrorCodes = [
  'auth_account_not_found',
  'auth_air_unavailable',
  'auth_csrf_invalid',
  'auth_google_provider_error',
  'auth_identity_inactive',
  'auth_network_error',
  'auth_school_provider_error',
  'auth_session_expired',
  'auth_unknown_email_not_approved',
  'auth_unknown_error',
] as const;

export const authErrorCodeSchema = z.enum(authErrorCodes);
export type AuthErrorCode = z.infer<typeof authErrorCodeSchema>;

export const AuthCodewords = {
  auth_account_not_found: 'LEMON',
  auth_air_unavailable: 'PUZZLE',
  auth_csrf_invalid: 'BIKE',
  auth_google_provider_error: 'PANDA',
  auth_identity_inactive: 'RAINBOW',
  auth_network_error: 'BALLOON',
  auth_school_provider_error: 'ZEBRA',
  auth_session_expired: 'TREE',
  auth_unknown_email_not_approved: 'CLOCK',
  auth_unknown_error: 'OCEAN',
} as const satisfies Record<AuthErrorCode, CodewordId>;

export const serverAuthErrorCodes = [
  'auth_account_not_found',
  'auth_air_unavailable',
  'auth_csrf_invalid',
  'auth_identity_inactive',
  'auth_session_expired',
  'auth_unknown_email_not_approved',
  'auth_unknown_error',
] as const satisfies readonly AuthErrorCode[];

export type ServerAuthErrorCode = (typeof serverAuthErrorCodes)[number];

export function isServerAuthErrorCode(value: unknown): value is ServerAuthErrorCode {
  return typeof value === 'string' && serverAuthErrorCodes.some((code) => code === value);
}

export const authErrorResponseSchema = z.object({
  name: z.literal('AirServerError'),
  code: authErrorCodeSchema,
  message: z.string(),
  codeword: codewordIdSchema,
});

export type AuthErrorResponse = z.infer<typeof authErrorResponseSchema>;

export function authErrorResponse(code: AuthErrorCode, message: string): AuthErrorResponse {
  return {
    name: 'AirServerError',
    code,
    message,
    codeword: AuthCodewords[code],
  };
}
